import { get } from 'lodash';
import { getButtonMaxWidth, getButtonMinWidth } from '../../utils/button-utils';
import * as cssUtils from '../../utils/css-utils';
import { extractButton } from '../../utils/elements';
import { getContentWidth } from '../../utils/get-message-width';
export const getButtonSection = ({ composerData, experiments, isRtl, region, css, }) => {
    const customStyles = get(region, 'data.styles.main') || {};
    const defaultStyles = composerData.styles.css['so-global-b1'];
    const rules = [
        get(region, 'data.styles.region', {}),
        css['so-global-region-button'],
        css['so-global-region'],
    ];
    const visibility = get(region, 'data.visibility');
    const mobileCssClass = cssUtils.getRegionMobileCssClass(rules, true, visibility);
    const padding = cssUtils.padding(rules);
    const margin = cssUtils.margin(rules);
    const containerBackground = cssUtils.containerBackgroundColor(rules);
    const borderWidth = cssUtils.containerBorderWidth(rules);
    const borderStyle = cssUtils.containerBorderStyle(rules);
    const borderColor = cssUtils.containerBorderColor(rules);
    const border = (!!borderStyle &&
        [borderWidth, borderStyle, borderColor].filter(Boolean).join(' ')) ||
        undefined;
    const emailContentWidth = getContentWidth(composerData, css, rules) - padding.left - padding.right;
    const maxWidth = getButtonMaxWidth(defaultStyles, '300px', emailContentWidth);
    const minWidth = getButtonMinWidth(customStyles, defaultStyles, '0px', emailContentWidth);
    const button = extractButton({
        customStyles,
        defaultStyles,
        experiments,
        isRtl,
        region,
    });
    return {
        cssClass: mobileCssClass,
        button,
        minWidth: `${minWidth}px`,
        maxWidth: `${maxWidth}px`,
        outerPadding: margin,
        innerPadding: padding,
        containerBackground,
        border,
        visibility,
    };
};
//# sourceMappingURL=get-button-section.js.map